import {
  Order,
  SortingInterface,
} from "@/helpers/pageHelpers/Common/interface";

export const getSortOption = (option: string): SortingInterface => ({
  field: option.split("-")[0],
  direction: option.split("-")[1] as Order,
});
